import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

export interface AppRecoveryData {
  reload: () => Promise<void>;
}

@Component({
  selector: 'lib-app-recovery',
  imports: [MatDialogModule, MatButton],
  templateUrl: './app-recovery.component.html',
  styleUrl: './app-recovery.component.scss',
})
export class AppRecoveryComponent {
  private readonly data = inject<AppRecoveryData>(MAT_DIALOG_DATA);
  protected readonly isReloading = signal(false);
  protected readonly reloadFailed = signal(false);

  protected async reload(): Promise<void> {
    if (this.isReloading()) {
      return;
    }

    this.isReloading.set(true);
    this.reloadFailed.set(false);
    try {
      await this.data.reload();
    } catch {
      this.reloadFailed.set(true);
      this.isReloading.set(false);
    }
  }
}
